export default __webpack_public_path__ + "45ca69315af773c215afd3ba873025e2.ttf";